import React from "react";
import "./LogoTitulo.css";

const LogoTitulo = () => {
  return (
    <div className="container">
      <div className="login-Titulo">
        <img src="./logo_sgf.png" alt="Logo" className="logo-container" />
        <h1>Sisprot BI</h1>
      </div>
    </div>
  );
}

export default LogoTitulo;
